import { Activity } from "@/types/activity";
import { api } from "..";

export const activityApi = api.injectEndpoints({
  endpoints: (build) => ({
    // 获取活动列表
    getActivitys: build.query<Activity[], void>({
      query:()=>`/activitys`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    }),
    // 获取活动列表
    getActivity: build.query<Activity, {activity_id:string}>({
      query:({activity_id})=>`/activitys/${activity_id}`,
      transformErrorResponse: (baseQueryReturnValue, meta, arg) => baseQueryReturnValue.data,
    })
  }),
});

export const { useGetActivitysQuery } = activityApi;


